"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconItalic', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M4.79999 15.154L4.99367 14.3029C5.43883 14.0257 5.90096 13.8025 6.37472 13.6358L8.13473 2.2262L7.19157 2.01917C6.98104 2.01917 6.87999 1.84665 6.87999 1.65112C6.91787 1.34375 7.00721 1.05247 7.14104 0.800003H11.2L11.0063 1.65112C10.5611 1.92829 10.099 2.15151 9.62525 2.31821L7.83157 13.7278L8.77472 13.9808C8.98525 13.9808 9.0863 14.1534 9.0863 14.3489C9.05857 14.6524 8.98083 14.9434 8.85894 15.2L4.79999 15.154Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M6 17.9489L6.24211 17.0032C6.79856 16.6952 7.37621 16.4472 7.96842 16.262L10.1684 3.58466L8.98947 3.35463C8.72632 3.35463 8.6 3.16294 8.6 2.94569C8.64735 2.60416 8.75902 2.28052 8.92632 2H14L13.7579 2.94569C13.2014 3.25365 12.6238 3.50168 12.0316 3.6869L9.78947 16.3642L10.9684 16.6454C11.2316 16.6454 11.3579 16.8371 11.3579 17.0543C11.3232 17.3916 11.2261 17.7149 11.0737 18L6 17.9489Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M7.20001 22.731L7.49054 21.4543C8.15828 21.0386 8.85147 20.7037 9.56212 20.4537L12.2021 3.3393L10.7874 3.02875C10.4716 3.02875 10.32 2.76997 10.32 2.47668C10.3768 2.01562 10.5108 1.57871 10.7116 1.2H16.8L16.5095 2.47668C15.8417 2.89243 15.1486 3.22727 14.4379 3.47732L11.7474 20.5917L13.1621 20.9712C13.4779 20.9712 13.6295 21.23 13.6295 21.5233C13.5879 21.9786 13.4713 22.4151 13.2884 22.8L7.20001 22.731Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M9.59998 30.308L9.98734 28.6057C10.8777 28.0514 11.8019 27.605 12.7494 27.2716L16.2694 4.45239L14.3831 4.03834C13.9621 4.03834 13.76 3.69329 13.76 3.30223C13.8357 2.68749 14.0144 2.10494 14.2821 1.6H22.4L22.0126 3.30223C21.1223 3.85657 20.198 4.30302 19.2505 4.63642L15.6631 27.4556L17.5494 27.9617C17.9705 27.9617 18.1726 28.3067 18.1726 28.6978C18.1171 29.3048 17.9617 29.8868 17.7179 30.4L9.59998 30.308Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;